import AccessControl from '../shared/user/AccessControl';

export const canEditUser = (actorRoles, targetRoles) => {
  const grantedRoles = new AccessControl().getAllRoles(actorRoles || []);

  return (
    grantedRoles.includes('ROLE_MANAGER') &&
    (targetRoles || []).every((role) => grantedRoles.includes(role))
  );
};
